import { render } from "./ImmunizationModal.vue?vue&type=template&id=48a6c37e&scoped=true"
import script from "./ImmunizationModal.vue?vue&type=script&lang=js"
export * from "./ImmunizationModal.vue?vue&type=script&lang=js"

import "./ImmunizationModal.vue?vue&type=style&index=0&id=48a6c37e&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48a6c37e"]])

export default __exports__